let cachedToken: string | null = null;
let tokenExpiresAt: number | null = null;
let tokenPromise: Promise<string> | null = null;

type TokenResponse = {
  token: string;
  expirySeconds: number;
  generationDate: string;
};

export const getAgentToken = async () => {
  if (cachedToken && tokenExpiresAt && Date.now() < tokenExpiresAt) {
    return cachedToken;
  }

  if (tokenPromise) {
    return tokenPromise;
  }

  tokenPromise = (async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BANKNOW_API_URL}/v1/users/generate-internal-token-agent`,
      {
        method: 'POST',
        headers: {
          clientId: process.env.REACT_APP_AGENT_CLIENT_ID,
          clientSecret: process.env.REACT_APP_AGENT_CLIENT_SECRET,
        },
      }
    );

    if (!response.ok) {
      tokenPromise = null;
      throw new Error('Erro ao gerar token do agente');
    }

    const data: TokenResponse = await response.json();

    cachedToken = data.token;

    const generationTime = new Date(data.generationDate).getTime();
    
    tokenExpiresAt = generationTime + (data.expirySeconds * 1000) - 30000;

    if (Date.now() > tokenExpiresAt) {
        cachedToken = null;
        tokenExpiresAt = null;
    }

    tokenPromise = null;
    return cachedToken;
  })();

  return tokenPromise;
};

export const authorizedFetch = async (
  url: string,
  options: RequestInit = {}
) => {
  let token = await getAgentToken();

  let response = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (response.status === 401) {
    cachedToken = null;
    tokenExpiresAt = null;

    token = await getAgentToken();

    response = await fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  }

  return response;
};
